export const ARCTIC_COACH_URL = "https://chatgpt.com/g/g-6982fb82923481918a6ed2bdaeadd1ac-lapland-ai-lab-arctic-coach";

export const getArcticCoachUrl = (content: string) => {
  return `${ARCTIC_COACH_URL}?utm_source=laplandailab&utm_medium=site&utm_campaign=arctic_coach&utm_content=${content}`;
};
